module.exports = __webpack_public_path__ + "img/Speaker=Akshaya Dinesh.f11559fb.png";